import React from "react";

export default function ZPartner01GrabFooter() {
    return (
        <div className="absolute-footer dark bg-white mt-5">
            <div className="container clearfix">
                <p className="float-none mb-1 text-center text-black-50">©2026 Coffee Concepts Retail Co.,Ltd. All rights reserved.</p>
            </div>
        </div>
    );
}
